import React, { useState } from 'react';
import './SupportPage.css';
import Layout from '../../components/layout/Layout';

const SupportPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Basic validation
    if (
      !formData.name ||
      !formData.email ||
      !formData.subject ||
      !formData.message
    ) {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    // Simulate form submission
    setSubmitted(true);
  };

  return (
    <Layout>
      <div className="support-page-container">
        <div className="support-header">
          <h1 className="support-page-title">Suporte Técnico</h1>
          <p className="support-page-description">
            Precisa de ajuda? Estamos aqui para ajudar. Utilize os recursos
            abaixo para resolver seu problema ou entre em contato com nossa
            equipe de suporte técnico.
          </p>
        </div>

        <div className="support-content">
          <div className="support-form-container">
            <h2>Entre em Contato</h2>
            <p>
              Preencha o formulário abaixo e nossa equipe entrará em contato o
              mais rápido possível.
            </p>

            {submitted ? (
              <div className="success-message">
                <p>
                  Sua solicitação foi enviada com sucesso! Nossa equipe entrará
                  em contato em breve.
                </p>
              </div>
            ) : (
              <form className="support-form" onSubmit={handleSubmit}>
                {error && <div className="error-message">{error}</div>}
                <div className="input-group">
                  <label htmlFor="name">Nome:</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Digite seu nome"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="email">Email:</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Digite seu email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="subject">Assunto:</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="Assunto do seu problema"
                    value={formData.subject}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="input-group">
                  <label htmlFor="message">Mensagem:</label>
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Descreva seu problema ou dúvida"
                    value={formData.message}
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                <button type="submit" className="support-submit-button">
                  Enviar Solicitação
                </button>
              </form>
            )}
          </div>

          <div className="support-resources-container">
            <h2>Recursos Adicionais</h2>
            <p>
              Antes de enviar uma solicitação, consulte nossos recursos
              adicionais para ver se a resposta à sua dúvida já está disponível.
            </p>
            <ul className="support-resources-list">
              <li>
                <a href="/ajuda/duvidas-frequentes">Dúvidas Frequentes (FAQ)</a>
              </li>
              <li>
                <a href="/ajuda/duvidas-frequentes">Tutoriais em Vídeo</a>
              </li>
              <li>
                <a href="/ajuda/duvidas-frequentes">Documentação Técnica</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SupportPage;
